import * as React from 'react'
import Helmet from 'react-helmet'
import { StaticQuery, graphql } from 'gatsby'

import 'modern-normalize'
import '../styles/normalize'

import { Location } from '@reach/router'
import Header from '../components/Header'
import Footer from '../components/Footer'
import LayoutRoot from '../components/LayoutRoot'
import LayoutMain from '../components/LayoutMain'
import { colors } from '../styles/variables'
import SiteMetadata from '../components/SiteMetadata'

interface StaticQueryProps {
  site: {
    siteMetadata: {
      title: string
      description: string
      keywords: string
    }
  }
}

function getBackgroundColor(pathName: string): string {
  switch (pathName) {
    case '/':
      return colors.brand
    case '/issues':
      return colors.lightBlue
    case '/issues/':
      return colors.lightBlue
    default:
      return colors.brand
  }
}

const IndexLayout: React.FC = ({ children }) => (
  <StaticQuery
    query={graphql`
      query IndexLayoutQuery {
        site {
          siteMetadata {
            title
            description
          }
        }
      }
    `}
    render={(data: StaticQueryProps) => (
      <Location>
        {({ location }) => (
          <LayoutRoot>
            <SiteMetadata />
            <Header title={data.site.siteMetadata.title} backgroundColor={getBackgroundColor(location.pathname)} />
            <LayoutMain>{children}</LayoutMain>
            <Footer />
          </LayoutRoot>
        )}
      </Location>
    )}
  />
)

export default IndexLayout
